import { Injectable } from '@angular/core';
import { FluxStandardAction } from 'flux-standard-action';
export type Action = FluxStandardAction<any, any>;

@Injectable()
export class ApiResponseActions {
  /**
   * Declaration of the action to set subscription of packages and wifi state
   **/
  static readonly SET_SUB_STATE = 'SET_SUB_STATE';
  /**
   * Declaration of the action to reset subscription of packages and wifi state
   **/
  static readonly SET_SUB_RES = 'SET_SUB_RES';
  /**
   * Declaration of the action to set add vehicle response
   **/
  static readonly SET_ADD_VEHICLE_RES = 'SET_ADD_VEHICLE_RES';
  /**
   * Declaration of the action to set the skip package subscription
   **/
  static readonly SKIP_PACKAGE_SUB = 'SKIP_PACKAGE_SUB';
  /**
   * Declaration of the action to RESET
   **/
  static readonly RESET_API_STORE = 'RESET_API_STORE';
  /**
   * Declaration of the action to set vinlist
   **/
  static readonly SET_VINLIST = 'SET_VINLIST';
  /**
   * Declaration of the action to set customer
   **/
  static readonly SET_CUSTOMER = 'SET_CUSTOMER';
  /**
   * Declaration of the action to set subscribed customer
   **/
  static readonly SET_UPDATE_CUSTOMER = 'SET_UPDATE_CUSTOMER';
  /**
 * Declaration of the action to set customer
 **/
  static readonly SET_SUBSCRIBED_CUSTOMER = 'SET_SUBSCRIBED_CUSTOMER';
  /**
   * Declaration of the action to set remote customer
   **/
  static readonly SET_REMOTE_CUSTOMER = 'SET_REMOTE_CUSTOMER';
  /**
 * Declaration of the action to set remote customer
 **/
  static readonly SET_REGISTER_CUSTOMER = 'SET_REGISTER_CUSTOMER';
  /**
   * Declaration of the action to set find vehicle
   **/
  static readonly SET_FIND_VEHICLE = 'SET_FIND_VEHICLE';
  /**
   * Declaration of the action to set metadata of vehicle
   **/
  static readonly SET_METADATA = 'SET_METADATA';
  /**
    * Declaration of the action to set preview
   **/
  static readonly SET_PREVIEW = 'SET_PREVIEW';
  /**
   * Declaration of the action to set Remote command
   **/
  static readonly SET_REMOTE_COMMAND = 'SET_REMOTE_COMMAND';
  /**
  * Declaration of the action to set Subscription History
  **/
  static readonly SET_SUBSCRIPTION_HISTORY = 'SET_SUBSCRIPTION_HISTORY';
  /**
  * Declaration of the action to set Customer History
  **/
  static readonly SET_CUSTOMER_HISTORY = 'SET_CUSTOMER_HISTORY';
  /**
   * Declaration of the action to get account history of subscribed customer
   **/
  static readonly SET_SUBSCRIPTION_HISTORY_CUSTOMER = 'SET_SUBSCRIPTION_HISTORY_CUSTOMER';
  /**
   * Declaration of the action to get provision history of vin
   **/
  static readonly SET_PROVISION_HISTORY = 'SET_PROVISION_HISTORY';
  /**
   * Declaration of the action to delete account
  **/
  static readonly DELETE_ACCOUNT = 'DELETE_ACCOUNT';
  /**
   * Declaration of the action to set wifi status
   **/
  static readonly SET_WIFI_STATUS = 'SET_WIFI_STATUS';
  /**
   * Declaration of the action to set wifi status
   **/
  static readonly SET_VERIFY_ADDRESS = 'SET_VERIFY_ADDRESS';
  /**
   * Declaration of the action to tci report status
   **/
  static readonly SET_TCI_REPORT = 'SET_TCI_REPORT';
  /**
   * Declaration of the action to sxm report status
   **/
  static readonly SET_SXM_REPORT = 'SET_SXM_REPORT';
  /**
   * Declaration of the action to telematics report status
   **/
  static readonly SET_TELEMATICS_REPORT = 'SET_TELEMATICS_REPORT';
  /**
  * Declaration of the action to set provisioning
  **/
  static readonly SET_GET_PROVISIONING = 'SET_GET_PROVISIONING';
  /**
  * Declaration of the action to retriger provisioning
  **/
  static readonly SET_RETRIGER_PROVISIONING = 'SET_RETRIGER_PROVISIONING';
  /**
  * Declaration of the action to set rejects
  **/
  static readonly SET_REJECTS = 'SET_REJECTS';
  /**
  * Declaration of the action to set vcm token
  **/
  static readonly SET_VCM_TOKEN = 'SET_VCM_TOKEN';
  /**
  * Declaration of the action to set vcm vin history
  **/
  static readonly SET_VCM_HISTORY = 'SET_VCM_HISTORY';
  /**
  * Declaration of the action to set vcm clear vin response
  **/
  static readonly SET_CLEAR_VIN = 'SET_CLEAR_VIN';
  /**
  * Declaration of the action to set vcm black list vin response
  **/
  static readonly SET_BLACKLIST_VIN = 'SET_BLACKLIST_VIN';
  /**
  * Declaration of the action to set vcm clear chip id response
  **/
  static readonly SET_CLEAR_CHIP_ID = 'SET_CLEAR_CHIP_ID';
  /**
  * Declaration of the action to update fanda
  **/
  static readonly UPDATE_FANDA = 'UPDATE_FANDA';
  /**
    * Declaration of the action to set update emergency contact
    **/
  static readonly SET_UPDATE_EMERGENCY_CONTACT = 'SET_UPDATE_EMERGENCY_CONTACT';
  /**
    * Declaration of the action to set emergency contact
    **/
  static readonly SET_EMERGENCY_CONTACT = 'SET_EMERGENCY_CONTACT';

  /**
  * Declaration of the action to set zuora customer information
  **/
  static readonly SET_ZUORA_CUSTOMER = 'SET_ZUORA_CUSTOMER';
  /**
   * Declaration of the action to set zuora customer information
   **/
  static readonly SET_JSD_GROUP_INFO = 'SET_JSD_GROUP_INFO';
  /**
   * Declaration of the action to set cms organization information
   **/
  static readonly SET_CMS_ORGANIZATION = 'SET_CMS_ORGANIZATION';
  /**
   * Declaration of the action to set validate user information
   **/
  static readonly SET_CMS_VALIDATE_USER = 'SET_CMS_VALIDATE_USER';
  /**
   * Declaration of the action to set group info information
   **/
  static readonly SET_CMS_REQUEST_GROUP_INFO = 'SET_CMS_REQUEST_GROUP_INFO';
  /**
   * Declaration of the action to set phone config information
   **/
  static readonly SET_PHONE_CONFIG = 'SET_PHONE_CONFIG';
  /**
   * Declaration of the action to set phone compatibilities information
   **/
  static readonly SET_PHONE_COMPATIBILITIES = 'SET_PHONE_COMPATIBILITIES';
  /**
   * Declaration of the action to set response of request group by id information
   **/
  static readonly SET_REQUEST_GROUP_ID = 'SET_REQUEST_GROUP_ID';
  /**
   * Declaration of the action to set response of get group fields information
   **/
  static readonly SET_CMS_REQUEST_GROUP_FIELDS = 'SET_CMS_REQUEST_GROUP_FIELDS';
  /**
   * Declaration of the action to set response of attach file information
   **/
  static readonly SET_CMS_ATTACH_FILE = 'SET_CMS_ATTACH_FILE';
  /**
   * Declaration of the action to set response of create ticket
   **/
  static readonly SET_CMS_CREATE_TICKET = 'SET_CMS_CREATE_TICKET';
  /**
  * Declaration of the action to set response of telematics services status
  **/
  static readonly SET_TSS = 'SET_TSS';
  /**
  * Declaration of the action to partial factory data feed
  **/
  static readonly SET_PARTIAL_FACTORY_DATA_FEED = 'SET_PARTIAL_FACTORY_DATA_FEED';
  /**
  * Declaration of the action to full factory data feed
  **/
  static readonly SET_FULL_FACTORY_DATA_FEED = 'SET_FULL_FACTORY_DATA_FEED';
  /**
  * Declaration of the action to air data feed
  **/
  static readonly SET_AIR_DATA_FEED = 'SET_AIR_DATA_FEED';
  /**
  * Declaration of the action to get user role
  **/
  static readonly SET_USER_ROLE = 'SET_USER_ROLE';
  /**
  * Declaration of the action to put user role update
  **/
  static readonly SET_USER_ROLE_UPDATE = 'SET_USER_ROLE_UPDATE';
  /*
   * Declaration of the action to validate cms user
   **/
  static readonly SET_VALIDATE_CMS_USER = 'SET_VALIDATE_CMS_USER';
  /*
   * Declaration of the action to GUID status
   **/
  static readonly SET_GUID_STATUS = 'SET_GUID_STATUS';
  /*
   * Declaration of the action to home dealer details
   **/
  static readonly SET_HOME_DEALER = 'SET_HOME_DEALER';
  /*
   * Declaration of the action to Preferred dealer details
   **/
  static readonly SET_PREFERRED_DEALER = 'SET_PREFERRED_DEALER';
  /*
   * Declaration of the action to set Banner Message
   **/
  static readonly SET_OUTAGE_BANNER_MESSAGE = 'SET_OUTAGE_BANNER_MESSAGE';
  /*
   * Declaration of the action to show the vehicle history
   **/
  static readonly SET_VEHICLE_HISTORY = 'SET_VEHICLE_HISTORY';
  /*
   * Declaration of the action to set the product packages
   **/
  static readonly SET_PRODUCT_PACKAGES = 'SET_PRODUCT_PACKAGES';
  /*
   * Declaration of the action to set the trial lengths
   **/
  static readonly SET_TRIAL_LENGTHS = 'SET_TRIAL_LENGTHS';
  /*
   * Declaration of the action to set the linked accounts
   **/
  static readonly SET_LINKED_ACCOUNTS = 'SET_LINKED_ACCOUNTS';
  /*
   * Declaration of the action to set the 21mm user profile settings
   **/
  static readonly SET_21MM_USER_PROFILE_SETTINGS = 'SET_21MM_USER_PROFILE_SETTINGS';
  /*
   * Declaration of the action to set the 21mm user profile settings
   **/
  static readonly SET_LOOKUP_KEY = 'SET_LOOKUP_KEY';
  /*
   * Declaration of the action to set the Goodwill packages
   **/
  static readonly SET_GOODWILL_PACKAGES = 'SET_GOODWILL_PACKAGES';
  /*
   * Declaration of the action to submit the Goodwill packages
   **/
  static readonly SUBMIT_GOODWILL_PACKAGES = 'SUBMIT_GOODWILL_PACKAGES';
  /*
   * Declaration of the action to get the data consents
   **/
  static readonly GET_DATA_CONSENTS = 'GET_DATA_CONSENTS';
  /*
   * Declaration of the action to get SMS consent
   **/
  static readonly GET_SMS_CONSENT = 'GET_SMS_CONSENT';  
  /*
  * Declaration of the action to set the user delete
  **/
  static readonly SET_USER_DELETE = 'SET_USER_DELETE';
  /*
  * Declaration of the action to update the remote user
  **/
  static readonly SET_UPDATE_REMOTE_USER = 'SET_UPDATE_REMOTE_USER';

  /*
  * Declaration of the action to get the HU COMPANY
  **/
  static readonly GET_HU_COMPANY = 'GET_HU_COMPANY';

  /*
* Declaration of the action to DCM activation
**/
  static readonly SET_DCM_ACTIVATION = 'SET_DCM_ACTIVATION';

   /*
* Declaration of the action to DCM activation
**/
static readonly RESET_DCM_ACTIVATION = 'RESET_DCM_ACTIVATION';

  /*
* Declaration of the action for PNC status
**/
static readonly SET_PNC_STATUS = 'SET_PNC_STATUS';
  /**
   * Declaration of the action to set survivor account
   **/
  static readonly SET_SURVIVOR_ACCOUNT = 'SET_SURVIVOR_ACCOUNT';

  /**
    * setSubscriptionResponse sets the subscription result for packages and wifi
    * @param result result of the api call
    **/
  static setSubscriptionResponse(result: object, type: string) {
    return {
      type: ApiResponseActions.SET_SUB_RES,
      payload: {
        response: { ...result },
        type: type,
        apiAction: ApiResponseActions.SET_SUB_RES,
      },
    };
  }
  /**
   * setSubscriptionState sets the waive
   * @param state flag
   **/
  static setSubscriptionState(state: boolean) {
    return {
      type: ApiResponseActions.SET_SUB_STATE,
      payload: { state, apiAction: ApiResponseActions.SET_SUB_STATE },
    };
  }
  /**
   * setSubHistoryCustomer sets the information for subscription customer
   * @param object returned by customer api call
   **/
  static setSubscriptionHistoryCustomer(state: object) {
    return {
      type: ApiResponseActions.SET_SUBSCRIPTION_HISTORY_CUSTOMER,
      payload: { state, apiAction: ApiResponseActions.SET_SUBSCRIPTION_HISTORY_CUSTOMER },
    };
  }
  /**
   * setVinlistResponse sets the vinlist result
   * @param result result of the api call
   **/
  static setVinlistResponse(result: Array<object>) {
    return {
      type: ApiResponseActions.SET_VINLIST,
      payload: {
        response: { ...result },
        apiAction: ApiResponseActions.SET_VINLIST,
      },
    };
  }
  /**
   * setPncStatus sets the vinlist result
   * @param result result of the api call
   **/
    static setPncStatusResponse(result: object) {
      return {
        type: ApiResponseActions.SET_PNC_STATUS,
        payload: {
          response: { ...result },
          apiAction: ApiResponseActions.SET_PNC_STATUS,
        },
      };
    }
  /**
   * setLookUpkeysResponse sets the setLookUpkeys result
   * @param result result of the api call
   **/
  static setLookUpkeysResponse(result: Array<object>) {
    return {
      type: ApiResponseActions.SET_LOOKUP_KEY,
      payload: {
        response: { ...result },
        apiAction: ApiResponseActions.SET_LOOKUP_KEY,
      },
    };
  }
  /**
   * setPreview sets the vinlist result
   * @param result result of the api call
   **/
  static setPreview(result: Array<object>) {
    return {
      type: ApiResponseActions.SET_PREVIEW,
      payload: {
        response: { ...result },
        apiAction: ApiResponseActions.SET_PREVIEW,
      },
    };
  }
  /**
   * setCustomerResponse sets the customer result
   * @param result result of the api call
   **/
  static setCustomerResponse(response: object) {
    return {
      type: ApiResponseActions.SET_CUSTOMER,
      payload: { response, apiAction: ApiResponseActions.SET_CUSTOMER },
    };
  }
  /**
   * setUpdateCustomerResponse sets the  updadtecustomer result
   * @param response result of the api call
   **/
  static setUpdateCustomerResponse(response: object) {
    return {
      type: ApiResponseActions.SET_UPDATE_CUSTOMER,
      payload: { response, apiAction: ApiResponseActions.SET_UPDATE_CUSTOMER },
    };
  }
  /**
   * setSubscribedCustomer sets the customer result
   * @param result result of the api call
   **/
  static setSubscribedCustomer(response: object) {
    return {
      type: ApiResponseActions.SET_SUBSCRIBED_CUSTOMER,
      payload: {
        response,
        apiAction: ApiResponseActions.SET_SUBSCRIBED_CUSTOMER,
      },
    };
  }
  /**
   * setRemoteCustomerResponse sets the remote customer result
   * @param result result of the api call
   **/
  static setRemoteCustomerResponse(response: object) {
    return {
      type: ApiResponseActions.SET_REMOTE_CUSTOMER,
      payload: { response, apiAction: ApiResponseActions.SET_REMOTE_CUSTOMER },
    };
  }
  /**
   * setRemoteCommandResponse sets the remote customer result
   * @param result result of the api call
   **/
  static setRemoteCommandResponse(response: object) {
    return {
      type: ApiResponseActions.SET_REMOTE_COMMAND,
      payload: { response, apiAction: ApiResponseActions.SET_REMOTE_COMMAND },
    };
  }
  /**
   * setCustomerResponse sets the vehicle result
   * @param result result of the api call
   **/
  static setfindVehicleResponse(response: object) {
    return {
      type: ApiResponseActions.SET_FIND_VEHICLE,
      payload: { response, apiAction: ApiResponseActions.SET_FIND_VEHICLE },
    };
  }
  /**
   * setMetaDataResponse sets the asi metadata result
   * @param result result of the api call
   **/
  static setMetaDataResponse(response: object) {
    return {
      type: ApiResponseActions.SET_METADATA,
      payload: { response, apiAction: ApiResponseActions.SET_METADATA },
    };
  }
  /**
    * setSubscriptionHistoryResponse sets the subscription history result
    * @param result result of the api call
    **/
  static setSubscriptionHistoryResponse(response: object) {
    return {
      type: ApiResponseActions.SET_SUBSCRIPTION_HISTORY,
      payload: { response, apiAction: ApiResponseActions.SET_SUBSCRIPTION_HISTORY }
    };
  }
  /**
  * setProvisionHistoryResponse sets the subscription history result
  * @param result result of the api call
  **/
  static setProvisionHistoryResponse(response: object) {
    return {
      type: ApiResponseActions.SET_PROVISION_HISTORY,
      payload: { response, apiAction: ApiResponseActions.SET_PROVISION_HISTORY }
    };
  }
  /**
    * setCustomerHistoryResponse sets the Customer history result
    * @param result result of the api call
    **/
  static setCustomerHistoryResponse(response: object) {
    return {
      type: ApiResponseActions.SET_CUSTOMER_HISTORY,
      payload: { response, apiAction: ApiResponseActions.SET_CUSTOMER_HISTORY }
    };
  }
  /**
    * setDeleteAccount sets the delete account result
    * @param result result of the api call
    **/
  static setDeleteAccountResponse(response: object) {
    return {
      type: ApiResponseActions.DELETE_ACCOUNT,
      payload: { response, apiAction: ApiResponseActions.DELETE_ACCOUNT },
    };
  }
  /**
   * setWifiStatusResponse sets the wifi status response
   * @param result result of the api call
   **/
  static setWifiStatusResponse(response: object) {
    return {
      type: ApiResponseActions.SET_WIFI_STATUS,
      payload: { response, apiAction: ApiResponseActions.SET_WIFI_STATUS },
    };
  }
  /**
   * setVerifyAddressResponse sets the verify address response
   * @param result result of the api call
   **/
  static setVerifyAddressResponse(response: object) {
    return {
      type: ApiResponseActions.SET_VERIFY_ADDRESS,
      payload: { response, apiAction: ApiResponseActions.SET_VERIFY_ADDRESS },
    };
  }
  /**
  * setGetProvisioningResponse sets the get provisioning response
  * @param result result of the api call
  **/
  static setGetProvisioningResponse(response: object) {
    return {
      type: ApiResponseActions.SET_GET_PROVISIONING,
      payload: { response, apiAction: ApiResponseActions.SET_GET_PROVISIONING }
    };
  }
  /**
  * setRetrigerProvisioningResponse sets the retriger provisioning response
  * @param result result of the api call
  **/
  static setRetrigerProvisioningResponse(response: object) {
    return {
      type: ApiResponseActions.SET_RETRIGER_PROVISIONING,
      payload: { response, apiAction: ApiResponseActions.SET_RETRIGER_PROVISIONING }
    };
  }

  /**
   * setTciReport sets the tci report response
   * @param result result of the api call
   **/
  static setTciReport(response: object) {
    return {
      type: ApiResponseActions.SET_TCI_REPORT,
      payload: { response, apiAction: ApiResponseActions.SET_TCI_REPORT },
    };
  }
  /**
   * setSxmReport sets the sxm report response
   * @param result result of the api call
   **/
  static setSxmReport(response: object) {
    return {
      type: ApiResponseActions.SET_SXM_REPORT,
      payload: { response, apiAction: ApiResponseActions.SET_SXM_REPORT },
    };
  }
  /**
   * setTelematicsReport sets the telematics report response
   * @param result result of the api call
   **/
  static setTelematicsReport(response: object) {
    return {
      type: ApiResponseActions.SET_TELEMATICS_REPORT,
      payload: { response, apiAction: ApiResponseActions.SET_TELEMATICS_REPORT },
    };
  }
  /**
   * setFandaRejects sets the get rejects response
   * @param result result of the api call
   **/
  static setFandaRejects(response: object) {
    return {
      type: ApiResponseActions.SET_REJECTS,
      payload: { response, apiAction: ApiResponseActions.SET_REJECTS },
    };
  }
  /**
   * set21mmToken sets the vcm access token
   * @param result result of the api call
   **/
  static set21mmToken(response: object) {
    return {
      type: ApiResponseActions.SET_VCM_TOKEN,
      payload: { response, apiAction: ApiResponseActions.SET_VCM_TOKEN },
    };
  }
  /**
   * SET_VCM_HISTORY sets the vcm history
   * @param result result of the api call
   **/
  static setVcmHistory(response: object) {
    return {
      type: ApiResponseActions.SET_VCM_HISTORY,
      payload: { response, apiAction: ApiResponseActions.SET_VCM_HISTORY },
    };
  }
  /**
   * setClearVin sets the setClearVin response
   * @param result result of the api call
   **/
  static setClearVin(response: object) {
    return {
      type: ApiResponseActions.SET_CLEAR_VIN,
      payload: { response, apiAction: ApiResponseActions.SET_CLEAR_VIN },
    };
  }
  /**
   * setBlackListVin sets the setClearVin response
   * @param result result of the api call
   **/
  static setBlackListVin(response: object) {
    return {
      type: ApiResponseActions.SET_BLACKLIST_VIN,
      payload: { response, apiAction: ApiResponseActions.SET_BLACKLIST_VIN },
    };
  }
  /**
   * setClearChipId sets the setClearChipId response
   * @param result result of the api call
   **/
  static setClearChipId(response: object) {
    return {
      type: ApiResponseActions.SET_CLEAR_CHIP_ID,
      payload: { response, apiAction: ApiResponseActions.SET_CLEAR_CHIP_ID },
    };
  }
  /**
   * UpdateFanda sets the get rejects response
   * @param result result of the api call
   **/
  static UpdateFanda(response: object) {
    return {
      type: ApiResponseActions.UPDATE_FANDA,
      payload: { response, apiAction: ApiResponseActions.UPDATE_FANDA },
    };
  }
  /**
     * setUpdateEmergencyContact sets the update emergency contact response
     * @param result result of the api call
     **/
  static setUpdateEmergencyContact(response: object) {
    return {
      type: ApiResponseActions.SET_UPDATE_EMERGENCY_CONTACT,
      payload: { response, apiAction: ApiResponseActions.SET_UPDATE_EMERGENCY_CONTACT },
    };
  }
  /**
     * setEmergencyContactResponse sets the  emergency contact response
     * @param result result of the api call
     **/
  static setEmergencyContactResponse(response: object) {
    return {
      type: ApiResponseActions.SET_EMERGENCY_CONTACT,
      payload: { response, apiAction: ApiResponseActions.SET_EMERGENCY_CONTACT },
    };
  }
  /**
   * setUpdateEmergencyContact sets the update emergency contact response
   * @param result result of the api call
   **/
  static setZuoraResponse(response: object) {
    return {
      type: ApiResponseActions.SET_ZUORA_CUSTOMER,
      payload: { response, apiAction: ApiResponseActions.SET_ZUORA_CUSTOMER },
    };
  }
  /**
   * setJsdGroupInfo sets jsd group info
   * @param result result of the api call
   **/
  static setJsdGroupInfoResponse(response: object) {
    return {
      type: ApiResponseActions.SET_JSD_GROUP_INFO,
      payload: { response, apiAction: ApiResponseActions.SET_JSD_GROUP_INFO },
    };
  }
  /**
 * setPhoneConfigResponse sets Phone Config Response
 * @param result result of the api call
 **/
  static setPhoneConfigResponse(response: object) {
    return {
      type: ApiResponseActions.SET_PHONE_CONFIG,
      payload: { response, apiAction: ApiResponseActions.SET_PHONE_CONFIG },
    };
  }
  /**
 * setPhoneCompatibilitiesResponse sets Phone Compatibilities Response
 * @param result result of the api call
 **/
  static setPhoneCompatibilitiesResponse(response: object) {
    return {
      type: ApiResponseActions.SET_PHONE_COMPATIBILITIES,
      payload: { response, apiAction: ApiResponseActions.SET_PHONE_COMPATIBILITIES },
    };
  }
  /**
   * setCmsCreateTicket sets jsd request group info
   * @param result result of the api call
   **/
  static setCmsCreateTicketResponse(response: object) {
    return {
      type: ApiResponseActions.SET_CMS_CREATE_TICKET,
      payload: { response, apiAction: ApiResponseActions.SET_CMS_CREATE_TICKET },
    };
  }
  /**
   * setTssResponse sets tss response
   **/
  static setTssResponse(response: object) {
    return {
      type: ApiResponseActions.SET_TSS,
      payload: { response, apiAction: ApiResponseActions.SET_TSS },
    };
  }

  /**
   * setPartialFactoryDataFeed sets the partial factory data feed response
   * @param result result of the api call
   **/
  static setPartialFactoryDataFeed(response: object) {
    return {
      type: ApiResponseActions.SET_PARTIAL_FACTORY_DATA_FEED,
      payload: { response, apiAction: ApiResponseActions.SET_PARTIAL_FACTORY_DATA_FEED },
    };
  }

  /**
   * setFullFactoryDataFeed sets the full factory data feed response
   * @param result result of the api call
   **/
  static setFullFactoryDataFeed(response: object) {
    return {
      type: ApiResponseActions.SET_FULL_FACTORY_DATA_FEED,
      payload: { response, apiAction: ApiResponseActions.SET_FULL_FACTORY_DATA_FEED },
    };
  }

  /**
   * setAirDataFeed sets the air data feed response
   * @param result result of the api call
   **/
  static setAirDataFeed(response: object) {
    return {
      type: ApiResponseActions.SET_AIR_DATA_FEED,
      payload: { response, apiAction: ApiResponseActions.SET_AIR_DATA_FEED },
    };
  }
  /**
   * setUserRole sets the data of user role response
   * @param result result of the api call
   **/
  static setUserRole(response: object) {
    return {
      type: ApiResponseActions.SET_USER_ROLE,
      payload: { response, apiAction: ApiResponseActions.SET_USER_ROLE },
    };
  }

  /**
   * setUserRoleUpdate sets the data of user role response
   * @param result result of the api call
   **/
  static setUserRoleUpdate(response: object) {
    return {
      type: ApiResponseActions.SET_USER_ROLE_UPDATE,
      payload: { response, apiAction: ApiResponseActions.SET_USER_ROLE_UPDATE },
    };
  }

  /**
   * setUserDelete sets the data of user delete response
   * @param result result of the api call
   **/
  static setUserDelete(response: object) {
    return {
      type: ApiResponseActions.SET_USER_DELETE,
      payload: { response, apiAction: ApiResponseActions.SET_USER_DELETE },
    };
  }

  /**
   * setValidateCMSUser sets cms authorize (validate user)api response
   * @param result result of the api call
   **/
  static setValidateCMSUser(response: object) {
    return {
      type: ApiResponseActions.SET_VALIDATE_CMS_USER,
      payload: { response, apiAction: ApiResponseActions.SET_VALIDATE_CMS_USER },
    };
  }

  /**
   * setGuidStatus sets the data of guid status response
   * @param result result of the api call
   **/
  static setGuidStatus(response: object) {
    return {
      type: ApiResponseActions.SET_GUID_STATUS,
      payload: { response, apiAction: ApiResponseActions.SET_GUID_STATUS },
    };
  }

  /**
   * setHomeDealer sets the data of preferred dealer details response
   **/
  static setHomeDealer(response: object) {
    return {
      type: ApiResponseActions.SET_HOME_DEALER,
      payload: { response, apiAction: ApiResponseActions.SET_HOME_DEALER },
    };
  }

  /**
   * setPreferredDealer sets the data of preferred dealer details response
   **/
  static setPreferredDealer(response: object) {
    return {
      type: ApiResponseActions.SET_PREFERRED_DEALER,
      payload: { response, apiAction: ApiResponseActions.SET_PREFERRED_DEALER },
    };
  }

  /**
   * setOutageBannerMessage sets the data of outage banner message response
   **/
  static setOutageBannerMessage(response: object) {
    return {
      type: ApiResponseActions.SET_OUTAGE_BANNER_MESSAGE,
      payload: { response, apiAction: ApiResponseActions.SET_OUTAGE_BANNER_MESSAGE },
    };
  }

  /**
   * setVehicleHistory sets the data of vehicle history
   **/
  static setVehicleHistory(response: object) {
    return {
      type: ApiResponseActions.SET_VEHICLE_HISTORY,
      payload: { response, apiAction: ApiResponseActions.SET_VEHICLE_HISTORY },
    };
  }

  /**
   * setPackageProducts sets the packages of the products
   **/
  static setPackageProducts(response: object) {
    return {
      type: ApiResponseActions.SET_PRODUCT_PACKAGES,
      payload: { response, apiAction: ApiResponseActions.SET_PRODUCT_PACKAGES },
    };
  }

  /**
   * setTrialLengthsResponse sets the trial lengths response
   **/
  static setTrialLengthsResponse(response: object) {
    return {
      type: ApiResponseActions.SET_TRIAL_LENGTHS,
      payload: { response, apiAction: ApiResponseActions.SET_TRIAL_LENGTHS },
    };
  }
  /**
   * setLinkedAccounts sets the linked accounts response
   **/
  static setLinkedAccounts(response: object) {
    return {
      type: ApiResponseActions.SET_LINKED_ACCOUNTS,
      payload: { response, apiAction: ApiResponseActions.SET_LINKED_ACCOUNTS },
    };
  }
  /**
   * set21MMUserProfileSettings sets the 21MM user profile settings
   **/
  static set21MMUserProfileSettings(response: object) {
    return {
      type: ApiResponseActions.SET_21MM_USER_PROFILE_SETTINGS,
      payload: { response, apiAction: ApiResponseActions.SET_21MM_USER_PROFILE_SETTINGS },
    };
  }
  /**
   * setGoodwillPackages sets the response after hitting the Goodwill packages API
   **/
  static setGoodwillPackages(response: object) {
    return {
      type: ApiResponseActions.SET_GOODWILL_PACKAGES,
      payload: { response, apiAction: ApiResponseActions.SET_GOODWILL_PACKAGES },
    };
  }
  /**
   * submitGoodwillPackages sets the response after hitting the submit Goodwill packages API
   **/
  static submitGoodwillPackages(response: object) {
    return {
      type: ApiResponseActions.SUBMIT_GOODWILL_PACKAGES,
      payload: { response, apiAction: ApiResponseActions.SUBMIT_GOODWILL_PACKAGES },
    };
  }
  /**
   * getDataConsents sets the response after hitting the getDataConsents API
   **/
  static getDataConsents(response: object) {
    return {
      type: ApiResponseActions.GET_DATA_CONSENTS,
      payload: { response, apiAction: ApiResponseActions.GET_DATA_CONSENTS },
    };
  } 
  /**
   * getSmsConsent sets the response after hitting GET /v1/portal/consent/account for customer SMS consent
   **/
  static getSmsConsent(response: object) {
    return {
      type: ApiResponseActions.GET_SMS_CONSENT,
      payload: { response, apiAction: ApiResponseActions.GET_SMS_CONSENT },
    };
  }

  /**
     * updateRemoteUser sets the response after hitting the updateRemoteUser API
     **/
  static updateRemoteUser(response: object) {
    return {
      type: ApiResponseActions.SET_UPDATE_REMOTE_USER,
      payload: { response, apiAction: ApiResponseActions.SET_UPDATE_REMOTE_USER },
    };
  }

  /**
   * getHuCompany sets the response after hitting the getHuCompany API
   **/
  static getHuCompany(response: object) {
    return {
      type: ApiResponseActions.GET_HU_COMPANY,
      payload: { response, apiAction: ApiResponseActions.GET_HU_COMPANY },
    };
  }


  /**
     * addDCMActivation sets the response after hitting the addDCMActivation API
     **/
  static addDCMActivation(response: object) {
    return {
      type: ApiResponseActions.SET_DCM_ACTIVATION,
      payload: { response, apiAction: ApiResponseActions.SET_DCM_ACTIVATION },
    };
  }
    /**
   * setSurvivorAccountResponse sets the survivor account result
   * @param result result of the api call
   **/
  static setSurvivorAccountResponse(result: Array<object>) {
    return {
      type: ApiResponseActions.SET_SURVIVOR_ACCOUNT,
      payload: {
        response: { ...result },
        apiAction: ApiResponseActions.SET_SURVIVOR_ACCOUNT,
      },
    };
  }
}
